import LocalStorageCache from 'localstorage-cache';
const cache = new LocalStorageCache(2048, 'LRU');
export default cache;
